module.exports = __webpack_public_path__ + "img/asob-hover.26d28665.png";